export const SYNC_TYPES = [
  {
    label: 'label.USERS',
    value: 'users'
  },
  {
    label: 'label.INDIVIDUAL_USER',
    value: 'individual'
  },
  {
    label: 'label.GROUPS',
    value: 'groups'
  },
  {
    label: 'label.ORGANIZATIONS',
    value: 'organizations'
  }
];

export const SYNC_SFTP_TYPES = [
  {
    label: 'SFTP',
    value: 'sftp'
  },
  {
    label: 'FTPS',
    value: 'ftps'
  }
];
